import { getToken } from '@/utils/auth'
export default {
    // 用户数据
    user: {
      userName: '',
      password: '',
      recommendUserId: '',
      isAuthenticated: false
    },
    wallet: 0,
    token: getToken(),
    
    // 筛选状态数据
    filters: {
        industryType: [],
        journaLevel: [],
        publicationCycle: [],
        journalBatch: [],
        collectionSource: []
    }
  }